import React, { useContext } from "react";
import { UmbracoContext, UmbracoStep } from "components/Umbraco/UmbracoContext";
import { isMobile } from "react-device-detect";
import icon1 from "images/Lobby/rebranding/icon1.svg";
import icon2 from "images/Lobby/rebranding/icon2.svg";
import icon3 from "images/Lobby/rebranding/icon3.svg";

import utils from "utils";
import { Between, IconSmall, IconTiny, InnerBig, LabelSubTitle, Line, Row } from "meitav-uikit";

const { UmbracoUtills } = utils;
const iconsArray = [icon1, icon2, icon3];

const that = this;

export default function Section5() {
  const resource = UmbracoStep(useContext(UmbracoContext).resource, "Section5");

  return (
    <Row className="section5 mt-3">
      <InnerBig className="wrapper">
        <Row className={`${isMobile ? "containerMobile" : ""}`}>
          <Between>
            <div className="borderSection" />
            <div
              className={`${isMobile ? "titleMobile col-8" : "title mx-5"
                }`}
            >
              <LabelSubTitle className="h1Accibility">
                {UmbracoUtills.getParsedHtmlValueByKey(resource, "title")}
              </LabelSubTitle>
            </div>
            <div className="borderSection" />
          </Between>
          <Between className="container">
            {iconsArray.map((icon, i) => {
              let index = i + 1;
              let resourceName = "part" + index + "Text";
              return (
                <Line key={index}>
                  <div className="col-md-3 col-3 ">
                    <div className="float-left icon-container accessibility">
                      <IconSmall src={icon} alt={`icon${index}`} ></IconSmall>
                    </div>
                  </div>
                  <div className="pass2">
                    <div className={`${isMobile ? "mt-2  " : ""} partText`}>
                      {UmbracoUtills.getParsedHtmlValueByKey(resource, resourceName)}
                    </div>
                  </div>
                </Line>)
            }
            )}
          </Between>
        </Row>
      </InnerBig>
    </Row>
  );
}
